/**
 * * end of cart upsell block part
 */
$(document).ready(function () {
  if (
    document.getElementById("essential-cart-drawer-portal") ||
    document.querySelector("essential-cart-app-embed")
  ) {
    return;
  }

  const amountFreeProduct = document.querySelector('[data-treshold-product]') ? document.querySelector('[data-treshold-product]').getAttribute('data-treshold-product') : null

  var cart_total = $(".gb-totals-total-value").first().text();
  if (amountFreeProduct > 0 && show_progress_bar) {
    /*GB! free product added STARTS*/
    setTimeout(function () {
      var cart_total = $(".gb-totals-total-value").first().text();
      if (cart_total >= amountFreeProduct) {
        if ($(".cart-item").hasClass("gb-find-remove-product")) {
          console.log("Free product already in cart");
        } else {
          console.log("Adding free product");
          $(".gb-free-product-trigger").trigger("click");
        }
      } else {
        console.log("Removing free product - under threshold");
        $(".gb-remove-product").trigger("click");
      }
    }, 3000);
    $("body").on("click", ".gb-sumbit-free", function () {
      setTimeout(function () {

        if (cart_total >= amountFreeProduct) {
          if ($(".cart-item").hasClass("gb-find-remove-product")) {
          } else {
            $(".gb-free-product-trigger").trigger("click");
          }
        } else {
          $(".gb-remove-product").trigger("click");
        }
      }, 3000);
    });

    // $("body").on("click", ".shop-add-to-cart-button", function () {
    //   setTimeout(function () {
    //     var cart_total = $(".gb-totals-total-value").first().text();
    //     if (cart_total >= amount_free_product) {
    //       if ($(".cart-item").hasClass("gb-find-remove-product")) {
    //       } else {
    //         $(".gb-free-product-trigger").trigger("click");
    //       }
    //     } else {
    //       $(".gb-remove-product").trigger("click");
    //     }
    //   }, 3000);
    // });
  }

  $("body").on(
    "click",
    ".gb-shipping-protection-button label.switch",
    async (e) => {
      if (e.target.tagName == "INPUT") return;
      const curElem = document.querySelector(
        ".gb-shipping-protection-button label.switch"
      );
      const curInputElem = document.querySelector(
        ".gb-shipping-protection-button label.switch input"
      );
      const spinAnim = document.querySelector(
        ".gb-shipping-protection-button .spin-animation"
      );
      const checkElem = document.querySelector(
        ".gb-shipping-protection-button .complete-check"
      );
      if (curElem.classList.contains("unchecked") && !curInputElem.checked) {
        if (spinAnim.style.display == "block" || curInputElem.checked) return;

        // $(".gb-product-shipping-protection-product-tirgger").trigger("click");
        const form = document.querySelector("form.shipping-protection-form");

        const formData = new FormData(form);
        if (!formData.get("id")) {
          console.error(
            "There is no shipping protection product selected. Please select the shipping product in the global theme settings"
          );
          return;
        }

        spinAnim.style.display = "block";

        try {
          const response = await fetch(routes.cart_add_url, {
            method: "POST",
            body: formData,
            headers: {
              Accept: "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
          });

          if (response.ok) {
            spinAnim.style.display = "none";

            checkElem.style.display = "block";
          }
        } catch (err) {
          console.error("error at shipping protection form submission", err);
        }
        fetch(routes.cart_url + "?view=drawer")
          .then((response) => response.text())
          .then((html) => {
            const cartDrawer = document.querySelector("#CartDrawer");
            const parsedCartHtml = parser.parseFromString(html, "text/html");
            const newCartDrawer = parsedCartHtml.querySelector("#CartDrawer");
            if (cartDrawer && newCartDrawer) {
              updateCartDrawer(cartDrawer, newCartDrawer, true, () => {
                curElem.classList.remove("unchecked");
                curElem.classList.add("checked");
                curInputElem.checked = true;
              });
            }
          })
          .catch((_err) => {
            curElem.classList.remove("unchecked");
            curElem.classList.add("checked");
            curInputElem.checked = true;
          });
      } else if (
        curElem.classList.contains("checked") &&
        curInputElem.checked
      ) {
        checkElem.style.display = "none";
        const cartDrawer = document.querySelector("#CartDrawer");
        const removeButton = cartDrawer.querySelector(
          `cart-remove-button[data-id="${shippingProductId}"]`
        );
        const shippingItemIndex = removeButton?.dataset.index;
        if (!removeButton || !shippingItemIndex) {
          return;
        }

        const cartItems =
          cartDrawer.querySelector("cart-items") ||
          cartDrawer.querySelector("cart-drawer-items");

        const event = new CustomEvent("remove-shipping-protection", {
          detail: null,
        });
        cartItems.updateQuantity(shippingItemIndex, 0, event, "", "", () => {
          curElem.classList.remove("checked");
          curElem.classList.add("unchecked");
          curInputElem.removeAttribute("checked");
        });
      }
    }
  );

  $("body").on("change", ".gb-change-variant_id", function () {
    var id_change = $(this).find(":selected").attr("data-variant-id");
    if (!id_change) {
      console.error("No data-variant-id found on selected option");
      return;
    }
    $(this)
      .closest(".gb-get-main-freq-pro")
      .find(".product-variant-id")
      .val(id_change);
  });
});

document.addEventListener("change", function (e) {
  if (
    e.target.matches(
      ".cart-drawer .gbfrequently-bought-with-main-whole .select__select"
    )
  ) {
    const parentBlock = e.target.closest(".gb-get-main-freq-pro");
    if (!parentBlock) {
      console.log("Error: Could not find parent block");
      return;
    }

    const allValues = Array.from(
      parentBlock.querySelectorAll(".select__select")
    )
      .map((sel) => sel.value)
      .join(" / ");

    const variantSelect = parentBlock.querySelector('[name="variants"]');
    if (!variantSelect) {
      console.log("Error: Could not find variant selector");
      return;
    }

    const matchedOption = Array.from(variantSelect.options).find((option) =>
      option.text.includes(allValues)
    );

    const idInput = parentBlock.querySelector('[name="id"]');
    if (!idInput) {
      console.log("Error: Could not find id input field");
      return;
    }

    if (matchedOption) {
      console.log("Matched variant option value:", matchedOption.value);
      idInput.value = matchedOption.value;
      console.log("Set ID input value to:", idInput.value);
    } else {
      console.log("No matching variant found for:", allValues);
    }
  }
});

// Add validation for form submissions to ensure ID parameter is present
document.addEventListener("submit", function (e) {
  if (e.target.action && e.target.action.includes("/cart/add")) {
    const idInput = e.target.querySelector('[name="id"]');
    if (!idInput || !idInput.value) {
      console.log("Preventing submission - missing id parameter");
      e.preventDefault();
      return false;
    }
  }
});

// Improve cart quantity handlers
$(document).ready(function () {
  // Ensure all cart quantity changes include product ID
  $(".cart-item .quantity__button, .cart-item .quantity__input").on(
    "click change input",
    function () {
      const cartItem = $(this).closest(".cart-item");
      const variantId = $(this)
        .closest(".quantity-input")
        .find(".quantity__input")
        .data("quantity-variant-id");

      // If this is a form submission, ensure the ID is included
      if ($(this).closest("form").length > 0) {
        let idInput = $(this).closest("form").find('input[name="id"]');
        if (idInput.length === 0 && variantId) {
          console.log("Adding missing ID input to cart form");
          $("<input>")
            .attr({
              type: "hidden",
              name: "id",
              value: variantId,
            })
            .appendTo($(this).closest("form"));
        } else if (idInput.length > 0 && variantId) {
          idInput.val(variantId);
        }
      }
    }
  );

  // Add validation for cart drawer checkout button
  $("#CartDrawer-Checkout").on("click", function (e) {
    const form = $("#CartDrawer-Form");
    if (form.length === 0) return;

    // Check if there are any items in the cart
    const cartItems = form.find(".cart-item");
    if (cartItems.length === 0) {
      console.log("No items in cart, preventing checkout");
      e.preventDefault();
      return false;
    }

    console.log("Cart checkout with", cartItems.length, "items");
  });

  /**
   * * Prevent redirecting to checkout when pressing enter at quantity input
   */
  $(document).on("keydown", ".quantity__input", function (e) {
    if (e.key === "Enter" || e.keyCode === 13) {
      e.preventDefault();
      $(this).trigger("blur");
    }
  });
  // * End of handler
});

// Fix for frequently bought products add to cart
$(document).ready(function () {
  if (
    document.getElementById("essential-cart-drawer-portal") ||
    document.querySelector("essential-cart-app-embed")
  ) {
    return;
  }

  // Find all frequently bought product forms or buttons
  $(
    ".gbfrequently-bought-with-main-whole button, .gbfrequently-bought-with-main-whole .gb-sumbit-free, .gb-free-product-trigger, .gb-product-shipping-protection-product-tirgger, .gb-product-sticky-add-to-cart-form"
  ).on("click", function (e) {
    const parentBlock = $(this).closest(".gb-get-main-freq-pro, form");
    if (!parentBlock) {
      console.error(
        "Could not find parent block for frequently bought product"
      );
      return;
    }

    // Find the product ID input or data attribute
    let productId = null;

    // Check for direct ID input
    const idInput = parentBlock.find('input[name="id"]');
    if (idInput.length > 0 && idInput.val()) {
      productId = idInput.val();
    }
    // Check for variant ID on select
    else if (parentBlock.find(".gb-change-variant_id").length > 0) {
      const selectedOption = parentBlock.find(
        ".gb-change-variant_id option:selected"
      );
      if (selectedOption.length > 0) {
        productId = selectedOption.data("variant-id");
      }
    }
    // Check for product-variant-id input
    else if (parentBlock.find(".product-variant-id").length > 0) {
      productId = parentBlock.find(".product-variant-id").val();
    }
    // Check for data attributes on the button itself
    else if ($(this).data("variant-id")) {
      productId = $(this).data("variant-id");
    }

    console.log("Frequently bought product add to cart - ID:", productId);

    if (
      this.classList.contains("gb-free-product-trigger") &&
      !show_progress_bar
    )
      return;

    // If no product ID found, prevent submission
    if (!productId) {
      console.error("Missing product ID for frequently bought product");
      e.preventDefault();
      return false;
    }

    // Update or create the ID input
    if (idInput.length === 0) {
      console.log("Adding missing ID input to frequently bought product form");
      $("<input>")
        .attr({
          type: "hidden",
          name: "id",
          value: productId,
        })
        .appendTo(parentBlock);
    } else {
      idInput.val(productId);
    }

    // Ensure quantity is included
    let quantityInput = parentBlock.find('input[name="quantity"]');
    if (quantityInput.length === 0) {
      console.log(
        "Adding default quantity input to frequently bought product form"
      );
      $("<input>")
        .attr({
          type: "hidden",
          name: "quantity",
          value: 1,
        })
        .appendTo(parentBlock);
    } else if (!quantityInput.val() || quantityInput.val() < 1) {
      quantityInput.val(1);
    }
  });
});

(function () {
  function openEssentialCartDrawer(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    document.dispatchEvent(
      new CustomEvent("essential-cart:open", {
        detail: { source: "header-cart-icon" },
      })
    );
  }

  function bindHeaderCartIcon() {
    var cartIcon = document.getElementById("cart-icon-bubble");
    if (!cartIcon || cartIcon.dataset.essentialCartBound === "true") {
      return;
    }

    cartIcon.dataset.essentialCartBound = "true";
    cartIcon.setAttribute("role", "button");
    cartIcon.setAttribute("aria-haspopup", "dialog");
    cartIcon.addEventListener("click", openEssentialCartDrawer);
  }

  document.addEventListener("DOMContentLoaded", bindHeaderCartIcon);
  document.addEventListener("shopify:section:load", bindHeaderCartIcon);

  var suppressCartRedirectUntil = 0;

  function essentialCartIsActive() {
    return (
      document.getElementById("essential-cart-drawer-portal") ||
      document.querySelector("essential-cart-app-embed")
    );
  }

  function openEssentialCartFromTheme(source) {
    document.dispatchEvent(
      new CustomEvent("essential-cart:open", {
        detail: { source: source || "theme-intercept" },
      })
    );
  }

  function armCartRedirectSuppression(ms) {
    suppressCartRedirectUntil = Date.now() + (ms || 2500);
  }

  function getEssentialCartPortal() {
    return document.getElementById("essential-cart-drawer-portal");
  }

  function getEssentialCartDialogTranslateX(dialog) {
    if (!dialog) return null;
    // Prefer inline style (cheap) before getComputedStyle
    var inline = dialog.style && dialog.style.transform;
    var transform = inline || "";
    if (!transform || transform === "none") {
      transform = window.getComputedStyle(dialog).transform || "";
    }
    if (!transform || transform === "none") return 0;
    var matrixMatch = transform.match(/matrix\(([^)]+)\)/);
    if (matrixMatch) {
      var parts = matrixMatch[1].split(",").map(function (value) {
        return parseFloat(value.trim());
      });
      if (parts.length >= 6 && !isNaN(parts[4])) return parts[4];
    }
    var translateXMatch = transform.match(/translateX\(([^)]+)\)/i);
    if (translateXMatch) {
      var tx = parseFloat(translateXMatch[1]);
      return isNaN(tx) ? 0 : tx;
    }
    var translateMatch = transform.match(/translate3?d?\(([^,)]+)/i);
    if (translateMatch) {
      var raw = parseFloat(translateMatch[1]);
      return isNaN(raw) ? 0 : raw;
    }
    return 0;
  }

  function isEssentialCartDialogOpen(dialog) {
    if (!dialog) return false;
    if (dialog.getAttribute("aria-hidden") === "true") return false;

    var translateX = getEssentialCartDialogTranslateX(dialog);
    if (Math.abs(translateX) >= 2) return false;

    if (dialog.getAttribute("aria-hidden") === "false") return true;

    var computed = window.getComputedStyle(dialog);
    return (
      computed.visibility !== "hidden" &&
      computed.display !== "none" &&
      computed.pointerEvents !== "none"
    );
  }

  function dismissKachingSaveOverlay() {
    document.querySelectorAll(".kaching-bundles-save-overlay").forEach(function (overlay) {
      overlay.classList.remove("kaching-bundles-save-overlay--visible");
      overlay.classList.add("kaching-bundles-save-overlay--dismissed");
      overlay.remove();
    });
  }

  function removeEssentialCartLockIcons() {
    document.querySelectorAll(".essential-cart-lock-icon").forEach(function (icon) {
      icon.remove();
    });
  }

  var BEAUMONT_CART_LOCK_SVG =
    '<svg class="beaumont-cart-secure-lock" width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
    '<rect x="5" y="11" width="14" height="10" rx="2" stroke="currentColor" stroke-width="2"/>' +
    '<path d="M8 11V8a4 4 0 0 1 8 0v3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
    "</svg>";

  // In-memory cart pricing cache — reopen / Markets reopen feel instant.
  var beaumontCartPricingCache = null;
  var beaumontCartPricingFetchPromise = null;
  var beaumontCartPricingRequestId = 0;
  var beaumontCartPricingLastFetchAt = 0;
  var beaumontCartPricingLastSignature = "";
  // Shopify's /cart.js line items don't carry compare_at_price, so savings would
  // otherwise be measured against the pre-discount unit price. Hydrate the real
  // compare-at from product JSON, keyed by variant and dropped on market change.
  var beaumontCompareAtByVariant = Object.create(null);
  var beaumontCompareAtCurrency = null;
  var beaumontCompareAtPending = Object.create(null);

  function getBeaumontActiveCurrency() {
    try {
      if (window.Shopify && Shopify.currency && Shopify.currency.active) {
        return String(Shopify.currency.active).toUpperCase();
      }
    } catch (e) {}
    if (beaumontCartPricingCache && beaumontCartPricingCache.currency) {
      return beaumontCartPricingCache.currency;
    }
    return null;
  }

  function formatBeaumontCartMoney(cents, currency) {
    var amount = (Number(cents) || 0) / 100;
    var code =
      (currency && String(currency).toUpperCase()) ||
      getBeaumontActiveCurrency() ||
      "USD";
    try {
      if (
        window.Shopify &&
        typeof Shopify.formatMoney === "function" &&
        (window.theme || window.Shopify) &&
        (Shopify.money_format ||
          (window.theme && theme.moneyFormat) ||
          (window.theme && theme.money_format))
      ) {
        var moneyFormat =
          Shopify.money_format ||
          (window.theme && (theme.moneyFormat || theme.money_format));
        if (moneyFormat) {
          return Shopify.formatMoney(Number(cents) || 0, moneyFormat);
        }
      }
    } catch (e) {}
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: code,
        currencyDisplay: "symbol",
      }).format(amount);
    } catch (e2) {
      return code + " " + amount.toFixed(2);
    }
  }

  function looksLikeMoneyText(text) {
    if (!text) return false;
    var t = String(text).replace(/\s+/g, " ").trim();
    if (!t || t.length > 40) return false;
    // Must contain a digit; avoid labels like "Subtotal" / placeholders
    if (!/\d/.test(t)) return false;
    if (/^(subtotal|total|shipping|free)/i.test(t)) return false;
    return true;
  }

  function readBeaumontDomMoneyText(portal) {
    if (!portal) return "";
    var selectors = [
      '[data-essential-cart-element="subtotal-amount"]',
      '[data-essential-cart-element="cart-drawer-property-value"]',
      '[data-essential-cart-element="cart-drawer-checkout-button-price"]',
      ".beaumont-cart-final-price",
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = portal.querySelector(selectors[i]);
      if (!el) continue;
      var text = (el.textContent || "").replace(/\s+/g, " ").trim();
      if (looksLikeMoneyText(text)) return text;
    }
    // Sum visible line prices as last-resort DOM hint (still market-formatted)
    var lineTotals = portal.querySelectorAll(
      '[data-essential-cart-element="cart-item-price"], [data-essential-cart-element="line-item-price"], .cart-item__price, .essential-cart-item-price'
    );
    if (lineTotals.length === 1) {
      var only = (lineTotals[0].textContent || "").replace(/\s+/g, " ").trim();
      if (looksLikeMoneyText(only)) return only;
    }
    return "";
  }

  function getBeaumontVariantCompareAt(item) {
    if (!item) return null;
    if (typeof item.compare_at_price === "number" && item.compare_at_price > 0) {
      return item.compare_at_price;
    }
    var currency = getBeaumontActiveCurrency();
    if (currency && beaumontCompareAtCurrency && currency !== beaumontCompareAtCurrency) {
      beaumontCompareAtByVariant = Object.create(null);
      beaumontCompareAtCurrency = currency;
      return null;
    }
    var cached = beaumontCompareAtByVariant[item.variant_id];
    return typeof cached === "number" && cached > 0 ? cached : null;
  }

  // Resolves true when fresh compare-at data landed and pricing should recompute.
  function hydrateBeaumontCompareAt(cart) {
    if (!cart || !cart.items || !cart.items.length) return Promise.resolve(false);

    var handles = [];
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (!item || !item.handle) continue;
      if (getBeaumontVariantCompareAt(item) !== null) continue;
      // 0 means we already looked it up and the variant has no compare-at.
      if (beaumontCompareAtByVariant[item.variant_id] === 0) continue;
      if (handles.indexOf(item.handle) === -1) handles.push(item.handle);
    }
    if (!handles.length) return Promise.resolve(false);

    var jobs = [];
    for (var h = 0; h < handles.length; h++) {
      jobs.push(fetchBeaumontProductCompareAt(handles[h]));
    }

    return Promise.all(jobs).then(function (results) {
      for (var r = 0; r < results.length; r++) {
        if (results[r]) return true;
      }
      return false;
    });
  }

  function fetchBeaumontProductCompareAt(handle) {
    if (beaumontCompareAtPending[handle]) return beaumontCompareAtPending[handle];

    var job = fetch("/products/" + encodeURIComponent(handle) + ".js", {
      credentials: "same-origin",
    })
      .then(function (res) {
        if (!res.ok) throw new Error("product fetch failed");
        return res.json();
      })
      .then(function (product) {
        var variants = (product && product.variants) || [];
        if (!variants.length) return false;
        beaumontCompareAtCurrency =
          getBeaumontActiveCurrency() || beaumontCompareAtCurrency;
        for (var v = 0; v < variants.length; v++) {
          var variant = variants[v];
          beaumontCompareAtByVariant[variant.id] =
            typeof variant.compare_at_price === "number" &&
            variant.compare_at_price > 0
              ? variant.compare_at_price
              : 0;
        }
        return true;
      })
      .catch(function () {
        return false;
      })
      .finally(function () {
        delete beaumontCompareAtPending[handle];
      });

    beaumontCompareAtPending[handle] = job;
    return job;
  }

  function computeBeaumontCartPricing(cart) {
    if (!cart || !cart.items || !cart.items.length) {
      return {
        finalCents: 0,
        compareCents: 0,
        discountPct: 0,
        showCompare: false,
        currency: (cart && cart.currency) || getBeaumontActiveCurrency() || null,
        itemCount: 0,
        token: (cart && cart.token) || "",
      };
    }

    var finalCents = 0;
    var compareCents = 0;
    var hasCompare = false;

    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var qty = item.quantity || 1;
      var lineFinal =
        typeof item.final_line_price === "number"
          ? item.final_line_price
          : typeof item.line_price === "number"
            ? item.line_price
            : (item.final_price || item.price || 0) * qty;
      finalCents += lineFinal;

      var unitCompare = getBeaumontVariantCompareAt(item);
      var unitPrice = item.final_price || item.price || 0;

      if (unitCompare && unitCompare > unitPrice) {
        hasCompare = true;
        compareCents += unitCompare * qty;
      } else if (
        typeof item.original_line_price === "number" &&
        item.original_line_price > lineFinal
      ) {
        hasCompare = true;
        compareCents += item.original_line_price;
      } else {
        compareCents += lineFinal;
      }
    }

    // Prefer cart totals when present (handles cart-level discounts)
    if (typeof cart.items_subtotal_price === "number") {
      finalCents = cart.items_subtotal_price;
    } else if (typeof cart.total_price === "number") {
      finalCents = cart.total_price;
    }

    if (
      typeof cart.original_total_price === "number" &&
      cart.original_total_price > finalCents &&
      cart.original_total_price > compareCents
    ) {
      compareCents = cart.original_total_price;
      hasCompare = true;
    }

    var showCompare = hasCompare && compareCents > finalCents && finalCents > 0;
    var discountPct = showCompare
      ? Math.round(((compareCents - finalCents) / compareCents) * 100)
      : 0;
    var currency =
      (cart.currency && String(cart.currency).toUpperCase()) ||
      getBeaumontActiveCurrency() ||
      null;

    return {
      finalCents: finalCents,
      compareCents: compareCents,
      discountPct: discountPct,
      showCompare: showCompare && discountPct > 0,
      currency: currency,
      itemCount: cart.item_count || cart.items.length,
      token: cart.token || "",
      finalText: formatBeaumontCartMoney(finalCents, currency),
      compareText: showCompare
        ? formatBeaumontCartMoney(compareCents, currency)
        : "",
    };
  }

  function pricingSignature(pricing) {
    if (!pricing) return "";
    return [
      pricing.finalCents || 0,
      pricing.compareCents || 0,
      pricing.discountPct || 0,
      pricing.showCompare ? 1 : 0,
      pricing.currency || "",
      pricing.finalText || "",
      pricing.itemCount || 0,
      pricing.token || "",
    ].join("|");
  }

  function mergeBeaumontPricing(base, overlay) {
    var out = {};
    var src = base || {};
    var over = overlay || {};
    var keys = [
      "finalCents",
      "compareCents",
      "discountPct",
      "showCompare",
      "currency",
      "itemCount",
      "token",
      "finalText",
      "compareText",
      "preferDomFinal",
      "optimistic",
    ];
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      if (over[k] !== undefined && over[k] !== null && over[k] !== "") {
        out[k] = over[k];
      } else if (src[k] !== undefined) {
        out[k] = src[k];
      }
    }
    return out;
  }

  function buildOptimisticBeaumontPricing(portal) {
    var domText = readBeaumontDomMoneyText(portal);
    var cached = beaumontCartPricingCache;
    var currency = getBeaumontActiveCurrency();

    if (cached) {
      var fromCache = mergeBeaumontPricing(cached, {
        currency: currency || cached.currency,
        optimistic: true,
      });
      // Prefer live DOM money string when Essential already rendered it
      // (correct for Markets / multi-currency locales).
      if (domText) {
        fromCache.finalText = domText;
        fromCache.preferDomFinal = true;
      }
      return fromCache;
    }

    if (domText) {
      return {
        finalCents: null,
        compareCents: 0,
        discountPct: 0,
        showCompare: false,
        currency: currency,
        finalText: domText,
        preferDomFinal: true,
        optimistic: true,
      };
    }

    return null;
  }

  function ensureBeaumontCartSubtotalPricing(portal, pricing, options) {
    var opts = options || {};
    var subtotalWrapper = portal.querySelector(
      '[data-essential-cart-element="subtotal-wrapper"]'
    );
    if (!subtotalWrapper) return;

    subtotalWrapper.classList.add("beaumont-cart-subtotal-wrapper");

    var row =
      subtotalWrapper.querySelector('[data-essential-cart-element="subtotal-row"]') ||
      subtotalWrapper.querySelector(
        '[data-essential-cart-element="cart-drawer-property-row"]'
      ) ||
      subtotalWrapper;

    row.classList.add("beaumont-cart-subtotal-row");

    var label =
      row.querySelector('[data-essential-cart-element="subtotal-label"]') ||
      row.querySelector('[data-essential-cart-element="cart-drawer-property-label"]');
    if (label) {
      label.textContent = "Subtotal";
      label.classList.add("beaumont-cart-subtotal-label");
    }

    var amountEl =
      row.querySelector('[data-essential-cart-element="subtotal-amount"]') ||
      row.querySelector('[data-essential-cart-element="cart-drawer-property-value"]');

    // Read native money BEFORE we hide it — Essential already formats for market.
    var nativeAmountText = "";
    if (amountEl) {
      nativeAmountText = (amountEl.textContent || "").replace(/\s+/g, " ").trim();
    }

    var pricingEl = row.querySelector("[data-beaumont-cart-pricing]");
    if (!pricingEl) {
      pricingEl = document.createElement("div");
      pricingEl.setAttribute("data-beaumont-cart-pricing", "true");
      pricingEl.className = "beaumont-cart-pricing";
      pricingEl.innerHTML =
        '<span class="beaumont-cart-discount-pill" hidden></span>' +
        '<span class="beaumont-cart-compare-price" hidden></span>' +
        '<span class="beaumont-cart-final-price"></span>';
      if (amountEl && amountEl.parentNode) {
        amountEl.parentNode.insertBefore(pricingEl, amountEl);
      } else {
        row.appendChild(pricingEl);
      }
    }

    var pill = pricingEl.querySelector(".beaumont-cart-discount-pill");
    var compareEl = pricingEl.querySelector(".beaumont-cart-compare-price");
    var finalEl = pricingEl.querySelector(".beaumont-cart-final-price");
    if (!pill || !compareEl || !finalEl) return;
    if (!pricing) return;

    var currency = pricing.currency || getBeaumontActiveCurrency();
    var existingFinal = (finalEl.textContent || "").replace(/\s+/g, " ").trim();

    // Final price priority for Markets correctness:
    // 1) Explicit finalText / preferDomFinal
    // 2) Native Essential amount currently in DOM
    // 3) Keep whatever is already painted (never blank flash)
    // 4) Format from cents only when we have real cents
    var finalText = "";
    if (pricing.preferDomFinal && pricing.finalText) {
      finalText = pricing.finalText;
    } else if (looksLikeMoneyText(nativeAmountText)) {
      finalText = nativeAmountText;
    } else if (pricing.finalText && looksLikeMoneyText(pricing.finalText)) {
      finalText = pricing.finalText;
    } else if (
      typeof pricing.finalCents === "number" &&
      pricing.finalCents >= 0 &&
      !pricing.optimistic
    ) {
      finalText = formatBeaumontCartMoney(pricing.finalCents, currency);
    } else if (looksLikeMoneyText(existingFinal)) {
      finalText = existingFinal;
    } else if (typeof pricing.finalCents === "number" && pricing.finalCents > 0) {
      finalText = formatBeaumontCartMoney(pricing.finalCents, currency);
    }

    // Paint final FIRST, then hide native — avoids blank flash
    if (finalText && finalEl.textContent !== finalText) {
      finalEl.textContent = finalText;
    }

    if (amountEl && looksLikeMoneyText(finalEl.textContent)) {
      amountEl.classList.add("beaumont-cart-native-amount-hidden");
      amountEl.setAttribute("aria-hidden", "true");
    }

    var compareReady =
      pricing.showCompare === true &&
      !pricing.optimistic &&
      (pricing.discountPct > 0 || looksLikeMoneyText(pricing.compareText));

    if (compareReady) {
      var pillText = pricing.discountPct + "% Off";
      var compareText =
        pricing.compareText ||
        formatBeaumontCartMoney(pricing.compareCents, currency);
      if (pill.hidden) pill.hidden = false;
      if (compareEl.hidden) compareEl.hidden = false;
      if (pill.textContent !== pillText) pill.textContent = pillText;
      if (compareEl.textContent !== compareText) compareEl.textContent = compareText;
    } else if (!opts.keepCompareWhileLoading) {
      // Optimistic paint: leave compare hidden until cart.js confirms —
      // do not invent % Off. If we already showed compare from cache, keep it.
      if (pricing.optimistic && pricing.showCompare && pricing.discountPct > 0) {
        var cachedPill = pricing.discountPct + "% Off";
        var cachedCompare =
          pricing.compareText ||
          (typeof pricing.compareCents === "number"
            ? formatBeaumontCartMoney(pricing.compareCents, currency)
            : "");
        if (cachedCompare) {
          if (pill.hidden) pill.hidden = false;
          if (compareEl.hidden) compareEl.hidden = false;
          if (pill.textContent !== cachedPill) pill.textContent = cachedPill;
          if (compareEl.textContent !== cachedCompare) {
            compareEl.textContent = cachedCompare;
          }
        }
      } else if (!pricing.optimistic && pricing.showCompare === false) {
        if (!pill.hidden) pill.hidden = true;
        if (!compareEl.hidden) compareEl.hidden = true;
        if (pill.textContent) pill.textContent = "";
        if (compareEl.textContent) compareEl.textContent = "";
      }
    }
  }

  // Replace Essential's discount savings row with Shipping / FREE EXPRESS SHIPPING.
  // Uses the same wrapper+row padding model as Subtotal so edges align.
  // Keeps the % Off pill on the subtotal price row untouched.
  function ensureBeaumontCartShippingRow(portal) {
    var SHIPPING_LABEL = "Shipping";
    var SHIPPING_VALUE = "FREE EXPRESS SHIPPING";

    var subtotalWrapper = portal.querySelector(
      '[data-essential-cart-element="subtotal-wrapper"]'
    );
    var discountWrapper = portal.querySelector(
      '[data-essential-cart-element="discount-code-wrapper"]'
    );
    var discountRow = portal.querySelector(
      '[data-essential-cart-element="discount-code-row"]'
    );
    var savingsLabel = portal.querySelector(
      '[data-essential-cart-element="discount-code-savings-label"]'
    );
    var savingsAmount = portal.querySelector(
      '[data-essential-cart-element="discount-code-amount"]'
    );

    function syncShippingText(labelEl, valueEl) {
      if (labelEl && labelEl.textContent !== SHIPPING_LABEL) {
        labelEl.textContent = SHIPPING_LABEL;
      }
      if (valueEl && valueEl.textContent !== SHIPPING_VALUE) {
        valueEl.textContent = SHIPPING_VALUE;
      }
    }

    function placeBeforeSubtotal(node) {
      if (!node || !subtotalWrapper || !subtotalWrapper.parentNode) return;
      if (node.nextElementSibling !== subtotalWrapper) {
        subtotalWrapper.parentNode.insertBefore(node, subtotalWrapper);
      }
    }

    // Prefer a clean injected row (sibling of subtotal-wrapper) so we don't fight
    // Essential's nested/floated discount markup. Hide the native savings UI.
    if (discountWrapper) {
      discountWrapper.classList.add("beaumont-hide-essential-savings");
    } else if (discountRow) {
      discountRow.style.display = "none";
    } else if (savingsLabel || savingsAmount) {
      if (savingsLabel) savingsLabel.style.display = "none";
      if (savingsAmount) savingsAmount.style.display = "none";
    }

    var existing = portal.querySelector("[data-beaumont-cart-shipping-row]");
    if (existing) {
      existing.classList.add("beaumont-cart-shipping-wrapper");
      var rowEl =
        existing.querySelector(".beaumont-cart-shipping-row") || existing;
      if (rowEl === existing) {
        // Legacy: shipping markup was the row itself — wrap to match subtotal.
        var legacyLabel = existing.querySelector(".beaumont-cart-shipping-label");
        var legacyValue = existing.querySelector(".beaumont-cart-shipping-value");
        if (legacyLabel && legacyValue) {
          var inner = document.createElement("div");
          inner.className = "beaumont-cart-shipping-row";
          inner.appendChild(legacyLabel);
          inner.appendChild(legacyValue);
          existing.appendChild(inner);
          existing.className = "beaumont-cart-shipping-wrapper";
          rowEl = inner;
        }
      } else {
        rowEl.classList.add("beaumont-cart-shipping-row");
      }
      syncShippingText(
        existing.querySelector(".beaumont-cart-shipping-label"),
        existing.querySelector(".beaumont-cart-shipping-value")
      );
      placeBeforeSubtotal(existing);
      return;
    }

    var footer =
      portal.querySelector('[data-essential-cart-element="cart-drawer-footer"]') ||
      (subtotalWrapper && subtotalWrapper.parentElement);
    if (!footer && !subtotalWrapper) return;

    var wrapper = document.createElement("div");
    wrapper.setAttribute("data-beaumont-cart-shipping-row", "true");
    wrapper.className = "beaumont-cart-shipping-wrapper";
    wrapper.innerHTML =
      '<div class="beaumont-cart-shipping-row">' +
      '<span class="beaumont-cart-shipping-label">' +
      SHIPPING_LABEL +
      "</span>" +
      '<span class="beaumont-cart-shipping-value">' +
      SHIPPING_VALUE +
      "</span>" +
      "</div>";

    if (subtotalWrapper && subtotalWrapper.parentNode) {
      subtotalWrapper.parentNode.insertBefore(wrapper, subtotalWrapper);
    } else {
      footer.appendChild(wrapper);
    }
  }

  function injectEssentialCartSecureCheckout(portal) {
    var button = portal.querySelector(
      '[data-essential-cart-element="cart-drawer-checkout-button"]'
    );
    if (!button) return;

    button.classList.add("beaumont-cart-secure-checkout");

    var textEl = button.querySelector(
      '[data-essential-cart-element="cart-drawer-checkout-button-text"]'
    );
    if (textEl) {
      // Rebuild label once — clearing Essential's original text avoids
      // "Secure Checkout Secure Checkout" (plain + our injected label).
      var priceInside = textEl.querySelector(
        '[data-essential-cart-element="cart-drawer-checkout-button-price"]'
      );
      var label = textEl.querySelector(".beaumont-cart-checkout-label");
      if (!label) {
        label = document.createElement("span");
        label.className = "beaumont-cart-checkout-label";
      }
      label.textContent = "Secure Checkout";

      while (textEl.firstChild) {
        textEl.removeChild(textEl.firstChild);
      }
      textEl.appendChild(label);
      if (priceInside) {
        textEl.appendChild(priceInside);
      }
    }

    var priceEl = button.querySelector(
      '[data-essential-cart-element="cart-drawer-checkout-button-price"]'
    );
    if (priceEl) {
      priceEl.classList.add("beaumont-cart-checkout-price-hidden");
      priceEl.setAttribute("aria-hidden", "true");
    }

    // Drop any plain duplicate text nodes / spans sitting on the button
    // outside our label + lock (Essential may leave a second CTA string).
    Array.prototype.slice.call(button.childNodes).forEach(function (node) {
      if (node.nodeType === 3 && node.textContent.trim()) {
        node.textContent = "";
      }
    });
    button.querySelectorAll("span, div, p").forEach(function (el) {
      if (
        el.classList.contains("beaumont-cart-checkout-label") ||
        el.classList.contains("beaumont-cart-secure-lock") ||
        el.classList.contains("beaumont-cart-checkout-shine") ||
        el.getAttribute("data-essential-cart-element") ===
          "cart-drawer-checkout-button-text" ||
        el.getAttribute("data-essential-cart-element") ===
          "cart-drawer-checkout-button-price" ||
        el.closest('[data-essential-cart-element="cart-drawer-checkout-button-text"]') ||
        el.closest(".beaumont-cart-secure-lock")
      ) {
        return;
      }
      var raw = (el.textContent || "").replace(/\s+/g, " ").trim().toLowerCase();
      if (
        raw === "secure checkout" ||
        raw === "checkout" ||
        raw === "check out"
      ) {
        el.remove();
      }
    });

    if (!button.querySelector(".beaumont-cart-secure-lock")) {
      button.insertAdjacentHTML("afterbegin", BEAUMONT_CART_LOCK_SVG);
    }
  }

  function injectBeaumontCartTrustRow(portal) {
    var checkoutWrapper = portal.querySelector(
      '[data-essential-cart-element="checkout-button-wrapper"]'
    );
    var footer =
      portal.querySelector('[data-essential-cart-element="cart-drawer-footer"]') ||
      (checkoutWrapper && checkoutWrapper.parentElement);
    if (!footer) return;

    var trustCopy = [
      "4.9 stars, 12,000+ Reviews",
      "Delivered in 1-3 Business Days",
      "30-day money-back guarantee",
    ];
    var trustHtml =
      '<div class="beaumont-cart-trust-item">' +
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 2.5l2.6 5.3 5.9.9-4.3 4.2 1 5.8L12 15.9 6.8 18.7l1-5.8L3.5 8.7l5.9-.9L12 2.5z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>' +
      "<span>" +
      trustCopy[0] +
      "</span>" +
      "</div>" +
      '<div class="beaumont-cart-trust-item">' +
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3 7h13v10H3V7zm13 3h3.5L22 13.5V17h-6v-7z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><circle cx="7" cy="18.5" r="1.5" fill="currentColor"/><circle cx="17.5" cy="18.5" r="1.5" fill="currentColor"/></svg>' +
      "<span>" +
      trustCopy[1] +
      "</span>" +
      "</div>" +
      '<div class="beaumont-cart-trust-item">' +
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6"/><path d="M12 7.5v9M14.2 9.2c-.5-.7-1.3-1.1-2.2-1.1-1.3 0-2.3.8-2.3 1.9s1 1.8 2.4 2.2c1.5.4 2.5 1 2.5 2.2s-1.1 2-2.5 2c-1 0-1.9-.5-2.4-1.3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' +
      "<span>" +
      trustCopy[2] +
      "</span>" +
      "</div>";

    var existing = portal.querySelector("[data-beaumont-cart-trust-row]");
    if (existing) {
      var spans = existing.querySelectorAll(".beaumont-cart-trust-item span");
      for (var i = 0; i < trustCopy.length && i < spans.length; i++) {
        if (spans[i].textContent !== trustCopy[i]) {
          spans[i].textContent = trustCopy[i];
        }
      }
      return;
    }

    var trust = document.createElement("div");
    trust.setAttribute("data-beaumont-cart-trust-row", "true");
    trust.className = "beaumont-cart-trust-row";
    trust.innerHTML = trustHtml;

    var paymentWrapper = portal.querySelector(
      '[data-essential-cart-element="payment-icons-wrapper"]'
    );

    if (paymentWrapper && paymentWrapper.parentNode) {
      paymentWrapper.parentNode.insertBefore(trust, paymentWrapper);
    } else if (checkoutWrapper && checkoutWrapper.parentNode) {
      if (checkoutWrapper.nextSibling) {
        checkoutWrapper.parentNode.insertBefore(trust, checkoutWrapper.nextSibling);
      } else {
        checkoutWrapper.parentNode.appendChild(trust);
      }
    } else {
      footer.appendChild(trust);
    }
  }

  function getOsmUrgencyBannerText() {
    var locale =
      (window.Shopify && Shopify.locale) ||
      document.documentElement.lang ||
      "en";
    locale = String(locale).toLowerCase().replace("_", "-");
    var lang = locale.split("-")[0];
    var copy = {
      en: "Every order is personally reviewed. Weekly intake is capped at 50 — 45 of 50 claimed this week.",
      es: "Cada pedido se revisa personalmente. El cupo semanal es de 50 — 45 de 50 reclamados esta semana.",
      fr: "Chaque commande est examinée personnellement. Quota hebdomadaire : 50 — 45 sur 50 réservés cette semaine.",
      de: "Jede Bestellung wird persönlich geprüft. Wöchentliches Limit: 50 — diese Woche 45 von 50 vergeben.",
      it: "Ogni ordine viene controllato personalmente. Limite settimanale: 50 — 45 su 50 prenotati questa settimana.",
      pt: "Cada pedido é revisado pessoalmente. Limite semanal: 50 — 45 de 50 reservados esta semana.",
      nl: "Elke bestelling wordt persoonlijk nagekeken. Weeklimiet: 50 — 45 van 50 deze week gereserveerd.",
      pl: "Każde zamówienie jest sprawdzane osobiście. Limit tygodniowy: 50 — 45 z 50 w tym tygodniu.",
      sv: "Varje order granskas personligen. Veckogräns: 50 — 45 av 50 bokade denna vecka.",
      da: "Hver ordre gennemgås personligt. Ugentlig grænse: 50 — 45 af 50 reserveret denne uge.",
      no: "Hver ordre gjennomgås personlig. Ukesgrense: 50 — 45 av 50 reservert denne uken.",
      fi: "Jokainen tilaus tarkistetaan henkilökohtaisesti. Viikkoraja: 50 — 45/50 varattu tällä viikolla.",
      ja: "すべてのご注文を個別に確認しています。週の受付上限は50、今週は45まで受付済みです。",
      ko: "모든 주문을 직접 검토합니다. 주간 한도 50개 중 이번 주 45개가 예약되었습니다.",
      zh: "每笔订单均经人工审核。每周限量50，本周已领取45。",
      ar: "تتم مراجعة كل طلب شخصيًا. الحد الأسبوعي 50 — تم حجز 45 من 50 هذا الأسبوع.",
      he: "כל הזמנה נבדקת באופן אישי. מכסה שבועית: 50 — 45 מתוך 50 הוזמנו השבוע.",
    };
    return copy[locale] || copy[lang] || copy.en;
  }

  function injectOsmUrgencyBanner(portal) {
    var paymentWrapper = portal.querySelector(
      '[data-essential-cart-element="payment-icons-wrapper"]'
    );
    var existing = portal.querySelector("[data-beaumont-osm-urgency-banner]");

    if (!paymentWrapper || !paymentWrapper.parentNode) {
      if (existing) existing.remove();
      return;
    }

    var urgencyText = getOsmUrgencyBannerText();

    function placeAfterPayment(node) {
      if (paymentWrapper.nextSibling) {
        paymentWrapper.parentNode.insertBefore(node, paymentWrapper.nextSibling);
      } else {
        paymentWrapper.parentNode.appendChild(node);
      }
    }

    if (existing) {
      var oldDot = existing.querySelector(".osm-urgency-dot");
      if (oldDot) oldDot.remove();
      var textEl = existing.querySelector(".osm-urgency-text");
      if (textEl && textEl.textContent !== urgencyText) {
        textEl.textContent = urgencyText;
      }
      if (paymentWrapper.nextElementSibling !== existing) {
        placeAfterPayment(existing);
      }
      return;
    }

    var banner = document.createElement("div");
    banner.className = "osm-urgency-banner";
    banner.setAttribute("data-beaumont-osm-urgency-banner", "true");
    banner.setAttribute("role", "status");
    banner.innerHTML = '<p class="osm-urgency-text"></p>';
    banner.querySelector(".osm-urgency-text").textContent = urgencyText;
    placeAfterPayment(banner);
  }

  function injectEssentialCartCheckoutShine() {
    var portal = getEssentialCartPortal();
    if (!portal) return;

    var button = portal.querySelector(
      '[data-essential-cart-element="cart-drawer-checkout-button"]'
    );
    if (!button || button.querySelector(".beaumont-cart-checkout-shine")) return;
    var shine = document.createElement("span");
    shine.className = "beaumont-cart-checkout-shine";
    shine.setAttribute("aria-hidden", "true");
    button.appendChild(shine);
  }

  function removeEssentialCartSecuredBanner() {
    var portal = getEssentialCartPortal();
    if (!portal) return;
    portal.querySelectorAll("[data-beaumont-cart-secured-banner]").forEach(function (banner) {
      banner.remove();
    });
    try {
      sessionStorage.removeItem("beaumont-cart-secured-end");
    } catch (e) {}
  }

  function applyBeaumontCartPricingToPortal(portal, pricing, options) {
    if (!portal || !pricing) return;
    var sig = pricingSignature(pricing);
    // Skip identical network writes to avoid mutation-observer thrash
    if (
      options &&
      options.skipIfUnchanged &&
      sig &&
      sig === beaumontCartPricingLastSignature &&
      portal.querySelector(".beaumont-cart-final-price") &&
      looksLikeMoneyText(
        (portal.querySelector(".beaumont-cart-final-price").textContent || "").trim()
      )
    ) {
      return;
    }
    ensureBeaumontCartSubtotalPricing(portal, pricing, options);
    if (!pricing.optimistic) {
      beaumontCartPricingLastSignature = sig;
    }
  }

  function paintBeaumontCartPricingOptimistic(portal) {
    var optimistic = buildOptimisticBeaumontPricing(portal);
    if (!optimistic) {
      // Still mount empty pricing shell so layout is stable; keep native amount
      // visible until we have something to show.
      var amountEl = portal.querySelector(
        '[data-essential-cart-element="subtotal-amount"], [data-essential-cart-element="cart-drawer-property-value"]'
      );
      if (amountEl && looksLikeMoneyText(amountEl.textContent)) {
        applyBeaumontCartPricingToPortal(
          portal,
          {
            finalText: (amountEl.textContent || "").replace(/\s+/g, " ").trim(),
            preferDomFinal: true,
            showCompare: false,
            optimistic: true,
            currency: getBeaumontActiveCurrency(),
          },
          { keepCompareWhileLoading: true }
        );
      }
      return !!optimistic;
    }
    applyBeaumontCartPricingToPortal(portal, optimistic, {
      keepCompareWhileLoading: true,
    });
    return true;
  }

  function fetchBeaumontCartJson(force) {
    var now = Date.now();
    // Reuse in-flight request (single-flight)
    if (beaumontCartPricingFetchPromise && !force) {
      return beaumontCartPricingFetchPromise;
    }
    // Fresh cache within 800ms — avoid hammering /cart.js on mutation storms
    if (
      !force &&
      beaumontCartPricingCache &&
      now - beaumontCartPricingLastFetchAt < 800
    ) {
      return Promise.resolve(beaumontCartPricingCache.__cart || null);
    }

    var requestId = ++beaumontCartPricingRequestId;
    beaumontCartPricingFetchPromise = fetch("/cart.js", {
      credentials: "same-origin",
      cache: "no-store",
    })
      .then(function (res) {
        if (!res.ok) throw new Error("cart fetch failed");
        return res.json();
      })
      .then(function (cart) {
        if (requestId !== beaumontCartPricingRequestId) {
          // Stale response — keep newer in-flight work authoritative
          return cart;
        }
        var pricing = computeBeaumontCartPricing(cart);
        // Prefer Essential's live DOM money string when present (Markets-safe)
        var portal = getEssentialCartPortal();
        var domText = portal ? readBeaumontDomMoneyText(portal) : "";
        if (domText) {
          pricing.finalText = domText;
          pricing.preferDomFinal = true;
        }
        pricing.__cart = cart;
        beaumontCartPricingCache = pricing;
        beaumontCartPricingLastFetchAt = Date.now();

        // Compare-at lookup is off the critical path: repaint only if it arrives
        // with data the first render couldn't know about.
        hydrateBeaumontCompareAt(cart)
          .then(function (changed) {
            if (!changed || requestId !== beaumontCartPricingRequestId) return;
            var livePortal = getEssentialCartPortal();
            var updated = computeBeaumontCartPricing(cart);
            var liveText = livePortal ? readBeaumontDomMoneyText(livePortal) : "";
            if (liveText) {
              updated.finalText = liveText;
              updated.preferDomFinal = true;
            }
            updated.__cart = cart;
            beaumontCartPricingCache = updated;
            if (!livePortal) return;
            suppressBeaumontCartObserver(300);
            applyBeaumontCartPricingToPortal(livePortal, updated, {
              skipIfUnchanged: true,
            });
          })
          .catch(function () {});

        return cart;
      })
      .catch(function (err) {
        if (requestId === beaumontCartPricingRequestId) {
          beaumontCartPricingFetchPromise = null;
        }
        throw err;
      })
      .finally(function () {
        if (requestId === beaumontCartPricingRequestId) {
          beaumontCartPricingFetchPromise = null;
        }
      });

    return beaumontCartPricingFetchPromise;
  }

  function refreshBeaumontCartFooterPricing(portal, options) {
    var opts = options || {};
    // 1) Instant paint from DOM / cache — never wait on network for final price
    paintBeaumontCartPricingOptimistic(portal);
    ensureBeaumontCartShippingRow(portal);

    // Don't hit /cart.js when the drawer isn't open — nothing on screen to refine.
    // Kills the background poll that otherwise ran every ~1s while idle/closed.
    if (!opts.force && !isEssentialCartDrawerVisible()) {
      return Promise.resolve();
    }

    var requestIdAtStart = beaumontCartPricingRequestId;
    return fetchBeaumontCartJson(!!opts.force)
      .then(function () {
        // Ignore if a newer force-fetch superseded this cycle's cache write
        if (
          opts.force &&
          beaumontCartPricingRequestId !== requestIdAtStart &&
          !beaumontCartPricingCache
        ) {
          return;
        }
        var pricing = beaumontCartPricingCache;
        if (!pricing) return;
        // Re-read DOM after Essential may have updated amounts
        var domText = readBeaumontDomMoneyText(portal);
        var refined = mergeBeaumontPricing(pricing, {
          optimistic: false,
          preferDomFinal: !!domText,
          finalText: domText || pricing.finalText,
        });
        suppressBeaumontCartObserver(300);
        applyBeaumontCartPricingToPortal(portal, refined, {
          skipIfUnchanged: !opts.force,
        });
        ensureBeaumontCartShippingRow(portal);
        return refined;
      })
      .catch(function () {
        // Network failed — keep whatever optimistic/DOM price is already painted.
        // Never wipe with $0 USD.
        paintBeaumontCartPricingOptimistic(portal);
        ensureBeaumontCartShippingRow(portal);
      });
  }

  function warmBeaumontCartPricingCache() {
    if (beaumontCartPricingCache && Date.now() - beaumontCartPricingLastFetchAt < 5000) {
      return;
    }
    fetchBeaumontCartJson(false).catch(function () {});
  }

  function normalizeEssentialCartButtons(portal) {
    if (portal.dataset.beaumontButtonsNormalized === "true") return;
    var buttons = portal.querySelectorAll(
      '[data-essential-cart-element="cart-drawer-checkout-button"], [data-essential-cart-element="essential-sticky-cart-container"] button, button[type="submit"]'
    );
    for (var i = 0; i < buttons.length; i++) {
      var button = buttons[i];
      button.classList.add("disable-global-button-styling");
      button.classList.remove(
        "button-gradient-effect",
        "gradient-shine-enabled",
        "button-box-shadow",
        "intensity-1",
        "intensity-2",
        "intensity-3",
        "intensity-4",
        "intensity-5"
      );
      if (button.style.transform) button.style.transform = "";
    }
    portal.dataset.beaumontButtonsNormalized = "true";
  }

  function normalizeEssentialCartLayout(options) {
    var portal = getEssentialCartPortal();
    if (!portal || portal.dataset.beaumontCartNormalizing === "true") return;

    portal.dataset.beaumontCartNormalizing = "true";
    // Cover the synchronous injections plus the async /cart.js pricing write that
    // lands shortly after, so none of them retrigger the drawer observer.
    suppressBeaumontCartObserver(700);
    try {
      normalizeEssentialCartButtons(portal);
      removeEssentialCartSecuredBanner();
      injectEssentialCartSecureCheckout(portal);
      injectEssentialCartCheckoutShine();
      injectBeaumontCartTrustRow(portal);
      injectOsmUrgencyBanner(portal);
      ensureBeaumontCartShippingRow(portal);
      // Structure footer first; paint prices from DOM/cache immediately;
      // refine compare-at / % Off via single-flight /cart.js.
      refreshBeaumontCartFooterPricing(portal, options || {});
    } finally {
      portal.dataset.beaumontCartNormalizing = "false";
    }
  }

  function rebindEssentialCartAfterMarketChange() {
    unlockPageScrollForEssentialCart();
    // Markets/currency switch — drop stale money strings & force fresh cart.js
    beaumontCartPricingCache = null;
    beaumontCartPricingLastSignature = "";
    beaumontCartPricingLastFetchAt = 0;
    beaumontCartPricingFetchPromise = null;
    beaumontCartPricingRequestId += 1;
    var portal = getEssentialCartPortal();
    if (portal) {
      delete portal.dataset.essentialCartDrawerBound;
      delete portal.dataset.beaumontButtonsNormalized;
    }
    bindEssentialCartDrawerObserver();
    scheduleEssentialCartNormalize(80, { force: true });
  }

  // Suppress our own drawer MutationObserver while WE rewrite the footer, so our
  // injections (secure-checkout label, pricing, shipping row) can't retrigger
  // normalize → /cart.js in an endless loop. Also lets us skip idle refetches.
  var beaumontObserverSuppressUntil = 0;
  function suppressBeaumontCartObserver(ms) {
    var until = Date.now() + (typeof ms === "number" ? ms : 500);
    if (until > beaumontObserverSuppressUntil) {
      beaumontObserverSuppressUntil = until;
    }
  }

  function isEssentialCartDrawerVisible() {
    var portal = getEssentialCartPortal();
    if (!portal) return false;
    return (
      portal.classList.contains("essential-cart-drawer-open") ||
      portal.classList.contains("essential-cart-drawer-opening")
    );
  }

  var essentialCartNormalizeTimer = null;
  function scheduleEssentialCartNormalize(delayMs, options) {
    if (essentialCartNormalizeTimer) {
      window.clearTimeout(essentialCartNormalizeTimer);
    }
    var opts = options || {};
    essentialCartNormalizeTimer = window.setTimeout(function () {
      essentialCartNormalizeTimer = null;
      removeEssentialCartLockIcons();
      normalizeEssentialCartLayout(opts);
      syncEssentialCartDrawerOpenState(true);
    }, typeof delayMs === "number" ? delayMs : 120);
  }

  var essentialCartScrollLockY = 0;
  var essentialCartScrollLockActive = false;

  function lockPageScrollForEssentialCart() {
    var root = document.documentElement;
    if (essentialCartScrollLockActive) {
      return;
    }

    essentialCartScrollLockY = window.scrollY || window.pageYOffset || 0;
    essentialCartScrollLockActive = true;
    root.classList.add("essential-cart-scroll-lock");
    root.style.setProperty("--essential-cart-scroll-lock-top", "-" + essentialCartScrollLockY + "px");
  }

  function unlockPageScrollForEssentialCart() {
    var root = document.documentElement;
    if (!essentialCartScrollLockActive) {
      return;
    }

    essentialCartScrollLockActive = false;
    root.classList.remove("essential-cart-scroll-lock");
    root.style.removeProperty("--essential-cart-scroll-lock-top");
    window.scrollTo(0, essentialCartScrollLockY);
  }

  function shouldBlockBackgroundScroll(event) {
    var portal = getEssentialCartPortal();
    if (!portal) {
      return false;
    }

    if (
      !portal.classList.contains("essential-cart-drawer-open") &&
      !portal.classList.contains("essential-cart-drawer-opening")
    ) {
      return false;
    }

    if (event.target instanceof Element && portal.contains(event.target)) {
      var scrollable = event.target.closest('[data-essential-cart-element="cart-drawer-content"]');
      return !scrollable;
    }

    return true;
  }

  document.addEventListener(
    "touchmove",
    function (event) {
      if (shouldBlockBackgroundScroll(event)) {
        event.preventDefault();
      }
    },
    { passive: false }
  );

  document.addEventListener(
    "wheel",
    function (event) {
      if (shouldBlockBackgroundScroll(event)) {
        event.preventDefault();
      }
    },
    { passive: false }
  );

  function syncEssentialCartDrawerOpenState(skipNormalize) {
    var portal = getEssentialCartPortal();
    if (!portal) return;

    var dialog = portal.querySelector('#cart-drawer [role="dialog"]');
    var overlay = portal.querySelector('[data-essential-cart-element="cart-drawer-overlay"]');
    var isOpen = isEssentialCartDialogOpen(dialog);

    portal.classList.toggle("essential-cart-drawer-open", isOpen);
    if (isOpen) {
      portal.classList.remove("essential-cart-drawer-opening");
    }

    if (isOpen || portal.classList.contains("essential-cart-drawer-opening")) {
      lockPageScrollForEssentialCart();
    } else {
      unlockPageScrollForEssentialCart();
    }

    if (!isOpen && overlay) {
      overlay.style.pointerEvents = "none";
    }

    if (!skipNormalize) {
      removeEssentialCartLockIcons();
      normalizeEssentialCartLayout();
    }
  }

  var essentialCartPollTimer = null;
  function pollEssentialCartDrawerOpenState(attempts) {
    if (essentialCartPollTimer) {
      window.clearTimeout(essentialCartPollTimer);
      essentialCartPollTimer = null;
    }

    var remaining = typeof attempts === "number" ? attempts : 24;
    var didNormalize = false;

    function tick() {
      syncEssentialCartDrawerOpenState(true);
      if (!didNormalize) {
        dismissKachingSaveOverlay();
      }

      var portal = getEssentialCartPortal();
      var dialog = portal && portal.querySelector('#cart-drawer [role="dialog"]');
      var isOpen = portal && isEssentialCartDialogOpen(dialog);

      if (isOpen) {
        if (!didNormalize) {
          didNormalize = true;
          normalizeEssentialCartLayout();
        }
        return;
      }

      if (remaining <= 0) {
        normalizeEssentialCartLayout();
        return;
      }

      remaining -= 1;
      essentialCartPollTimer = window.setTimeout(tick, 32);
    }

    tick();
  }

  function bindEssentialCartDrawerObserver() {
    var portal = getEssentialCartPortal();
    if (!portal || portal.dataset.essentialCartDrawerBound === "true") {
      return;
    }

    portal.dataset.essentialCartDrawerBound = "true";

    var dialog = portal.querySelector('#cart-drawer [role="dialog"]');
    var overlay = portal.querySelector(
      '[data-essential-cart-element="cart-drawer-overlay"]'
    );
    if (dialog) {
      var observer = new MutationObserver(function (mutations) {
        // Ignore the mutation storm we create while normalizing the footer.
        if (Date.now() < beaumontObserverSuppressUntil) return;
        var shouldIgnore = true;
        for (var i = 0; i < mutations.length; i++) {
          var target = mutations[i].target;
          if (!(target instanceof Element)) {
            shouldIgnore = false;
            break;
          }
          if (
            target.classList.contains("beaumont-cart-checkout-shine") ||
            target.classList.contains("beaumont-cart-secure-lock") ||
            target.closest("[data-beaumont-cart-pricing]") ||
            target.closest("[data-beaumont-cart-trust-row]") ||
            target.closest("[data-beaumont-osm-urgency-banner]") ||
            target.closest(".osm-urgency-banner") ||
            target.closest("[data-beaumont-cart-shipping-row]") ||
            target.closest(".beaumont-cart-shipping-row") ||
            target.classList.contains("beaumont-cart-discount-pill") ||
            target.classList.contains("beaumont-cart-compare-price") ||
            target.classList.contains("beaumont-cart-final-price") ||
            target.classList.contains("beaumont-cart-shipping-label") ||
            target.classList.contains("beaumont-cart-shipping-value") ||
            target.classList.contains("osm-urgency-dot") ||
            target.classList.contains("osm-urgency-text")
          ) {
            continue;
          }
          shouldIgnore = false;
          break;
        }
        if (shouldIgnore) return;
        // Clear button cache when cart DOM remounts items/footer
        delete portal.dataset.beaumontButtonsNormalized;
        scheduleEssentialCartNormalize(140);
      });
      observer.observe(dialog, {
        attributes: true,
        attributeFilter: ["style", "aria-hidden", "class"],
        childList: true,
        subtree: true,
      });
    }
    if (overlay) {
      var overlayObserver = new MutationObserver(function () {
        scheduleEssentialCartNormalize(80);
      });
      overlayObserver.observe(overlay, {
        attributes: true,
        attributeFilter: ["style", "aria-hidden", "class"],
      });
    }

    removeEssentialCartLockIcons();
    normalizeEssentialCartLayout();
    syncEssentialCartDrawerOpenState(true);
  }

  document.addEventListener("essential-cart:open", function () {
    var portal = getEssentialCartPortal();
    if (portal) {
      portal.classList.add("essential-cart-drawer-opening");
      portal.classList.remove("essential-cart-drawer-open");
      delete portal.dataset.beaumontButtonsNormalized;
      // Instant price paint in the same turn — before rAF / network
      paintBeaumontCartPricingOptimistic(portal);
      ensureBeaumontCartShippingRow(portal);
    }
    lockPageScrollForEssentialCart();
    dismissKachingSaveOverlay();
    removeEssentialCartLockIcons();
    // Defer full normalize one frame so drawer chrome paints immediately;
    // force cart.js refine for compare-at / % Off without blocking final price.
    window.requestAnimationFrame(function () {
      normalizeEssentialCartLayout({ force: true });
    });
    armCartRedirectSuppression(2500);
    pollEssentialCartDrawerOpenState(24);
  });

  document.addEventListener("click", function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;
    if (
      target.matches('[data-essential-cart-element="cart-drawer-overlay"]') ||
      target.closest('[data-essential-cart-element="cart-drawer-close"]')
    ) {
      window.setTimeout(function () {
        syncEssentialCartDrawerOpenState(true);
      }, 80);
      window.setTimeout(function () {
        syncEssentialCartDrawerOpenState(true);
      }, 220);
    }
  });

  // Market/currency switches remount the drawer — rebind cleanly for every country
  window.addEventListener("pagehide", unlockPageScrollForEssentialCart);
  window.addEventListener("pageshow", function () {
    rebindEssentialCartAfterMarketChange();
  });
  document.addEventListener("change", function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;
    if (
      target.matches(
        'localization-form select, select[name="country_code"], select[name="locale_code"], select[name="currency_code"]'
      )
    ) {
      rebindEssentialCartAfterMarketChange();
    }
  });
  document.addEventListener("submit", function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (
      form.matches("localization-form, form[action*='/localization']") ||
      form.closest("localization-form")
    ) {
      rebindEssentialCartAfterMarketChange();
    }
  });

  // Portal can be replaced after Markets/geolocation without a full reload
  if (!window.__beaumontEssentialCartPortalWatcher) {
    window.__beaumontEssentialCartPortalWatcher = true;
    var portalWatchTimer = null;
    var portalRootObserver = new MutationObserver(function (mutations) {
      var maybePortal = false;
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          if (!(node instanceof Element)) continue;
          if (
            node.id === "essential-cart-drawer-portal" ||
            node.querySelector?.("#essential-cart-drawer-portal")
          ) {
            maybePortal = true;
            break;
          }
        }
        if (maybePortal) break;
      }
      if (!maybePortal) return;
      if (portalWatchTimer) window.clearTimeout(portalWatchTimer);
      portalWatchTimer = window.setTimeout(function () {
        var portal = getEssentialCartPortal();
        if (portal && portal.dataset.essentialCartDrawerBound !== "true") {
          bindEssentialCartDrawerObserver();
          scheduleEssentialCartNormalize(80);
        }
      }, 120);
    });
    portalRootObserver.observe(document.body || document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  document.addEventListener("DOMContentLoaded", bindEssentialCartDrawerObserver);
  document.addEventListener("shopify:section:load", bindEssentialCartDrawerObserver);
  document.addEventListener("DOMContentLoaded", removeEssentialCartLockIcons);
  document.addEventListener("DOMContentLoaded", warmBeaumontCartPricingCache);
  if (document.readyState !== "loading") {
    bindEssentialCartDrawerObserver();
    removeEssentialCartLockIcons();
    warmBeaumontCartPricingCache();
  } else {
    // Warm cart snapshot as soon as possible so first open is instant
    if (window.requestIdleCallback) {
      window.requestIdleCallback(function () {
        warmBeaumontCartPricingCache();
      }, { timeout: 1500 });
    } else {
      window.setTimeout(warmBeaumontCartPricingCache, 400);
    }
  }

  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      if (!essentialCartIsActive()) return;
      var portal = getEssentialCartPortal();
      if (portal) delete portal.dataset.beaumontButtonsNormalized;
      // Cart contents changed — invalidate freshness window & force refine
      beaumontCartPricingLastFetchAt = 0;
      armCartRedirectSuppression(2500);
      pollEssentialCartDrawerOpenState(24);
      if (portal) {
        refreshBeaumontCartFooterPricing(portal, { force: true });
      } else {
        fetchBeaumontCartJson(true).catch(function () {});
      }
    });
  }

  var originalAssign = window.location.assign.bind(window.location);
  window.location.assign = function (url) {
    if (
      typeof url === "string" &&
      Date.now() < suppressCartRedirectUntil &&
      /\/cart\/?(\?|#|$)/.test(url)
    ) {
      openEssentialCartFromTheme("redirect-intercept");
      return;
    }
    return originalAssign(url);
  };

  try {
    var hrefDescriptor = Object.getOwnPropertyDescriptor(
      window.Location.prototype,
      "href"
    );
    if (hrefDescriptor && hrefDescriptor.set) {
      var originalHrefSet = hrefDescriptor.set;
      Object.defineProperty(window.location, "href", {
        configurable: true,
        enumerable: true,
        get: hrefDescriptor.get
          ? hrefDescriptor.get.bind(window.location)
          : function () {
              return window.location.toString();
            },
        set: function (url) {
          if (
            typeof url === "string" &&
            Date.now() < suppressCartRedirectUntil &&
            /\/cart\/?(\?|#|$)/.test(url)
          ) {
            openEssentialCartFromTheme("redirect-intercept");
            return;
          }
          return originalHrefSet.call(window.location, url);
        },
      });
    }
  } catch (error) {
    console.warn("Essential Cart redirect guard unavailable:", error);
  }
})();

(function () {
  function reinitializeKachingBundles(source) {
    var root = document.querySelector(".kaching-bundles");
    if (!root) return;

    window.kachingBundlesInitialized = false;

    if (typeof window.kachingBundlesInitialize === "function") {
      window.kachingBundlesInitialize();
      return;
    }

    if (typeof window.__kachingBundlesInitializeInternal === "function") {
      window.__kachingBundlesInitializeInternal();
    }
  }

  function bindKachingBundleBarClicks() {
    document.querySelectorAll(".kaching-bundles__bar").forEach(function (bar) {
      if (bar.dataset.bloomBundleBound === "true") return;
      bar.dataset.bloomBundleBound = "true";

      bar.addEventListener(
        "click",
        function (event) {
          if (
            event.target.closest(
              "select, .kaching-bundles__bar-variant-select, .kaching-bundles-option, .kaching-bundles__swatch-buttons__button"
            )
          ) {
            return;
          }

          var radio = bar.querySelector(".kaching-bundles__bar-radio");
          if (!radio || radio.checked) return;

          radio.checked = true;
          radio.dispatchEvent(new Event("change", { bubbles: true }));
          radio.dispatchEvent(new Event("input", { bubbles: true }));
        },
        true
      );
    });
  }

  function refreshKachingBundles(source) {
    reinitializeKachingBundles(source);
    bindKachingBundleBarClicks();
  }

  document.addEventListener("DOMContentLoaded", function () {
    refreshKachingBundles("dom-content-loaded");
  });

  window.addEventListener("pageshow", function (event) {
    if (event.persisted) {
      refreshKachingBundles("bfcache-restore");
    }
  });

  document.addEventListener("essential-cart:open", function () {
    window.__bloomKachingRefreshPending = true;
  });

  document.addEventListener("click", function (event) {
    if (!window.__bloomKachingRefreshPending) return;

    var portal = document.getElementById("essential-cart-drawer-portal");
    if (!portal || portal.contains(event.target)) return;

    window.__bloomKachingRefreshPending = false;
    setTimeout(function () {
      refreshKachingBundles("essential-cart-dismiss");
    }, 150);
  });

  var kachingObserver = new MutationObserver(function () {
    if (document.querySelector(".kaching-bundles__bar:not([data-bloom-bundle-bound='true'])")) {
      bindKachingBundleBarClicks();
    }
  });

  document.addEventListener("DOMContentLoaded", function () {
    kachingObserver.observe(document.body, { childList: true, subtree: true });
  });
})();

(function () {
  var body = document.body;
  if (
    !body.classList.contains("template-product-cardibcream") &&
    !body.classList.contains("template-product-stickybra") &&
    !body.classList.contains("template-product-luxe-foundation") &&
    !body.classList.contains("template-product-beaumont-nobs")
  ) {
    return;
  }

  var announcement = document.querySelector(".section-announcement");
  if (!announcement) return;

  function setAnnouncementHeight() {
    document.documentElement.style.setProperty(
      "--announcement-bar-height",
      announcement.offsetHeight + "px"
    );
  }

  setAnnouncementHeight();
  window.addEventListener("resize", setAnnouncementHeight);
})();

/* Luxe Foundation PDP — speed only (no copy/structure changes) */
(function () {
  if (!document.body.classList.contains("template-product-luxe-foundation")) return;

  function optimizeMedia() {
    var main = document.getElementById("MainContent");
    if (!main) return;

    var imgs = main.querySelectorAll("img");
    var firstHero = null;
    imgs.forEach(function (img, index) {
      if (!firstHero && img.offsetParent !== null && img.getBoundingClientRect().top < window.innerHeight * 1.2) {
        firstHero = img;
        img.setAttribute("fetchpriority", "high");
        img.setAttribute("loading", "eager");
        img.setAttribute("decoding", "async");
        return;
      }
      if (img.getAttribute("loading") !== "eager") {
        img.setAttribute("loading", "lazy");
      }
      img.setAttribute("decoding", "async");
      // Avoid huge decode work for far-below-fold decorative images
      if (index > 8 && !img.hasAttribute("width") && img.naturalWidth > 1600) {
        img.style.maxWidth = "100%";
        img.style.height = "auto";
      }
    });

    main.querySelectorAll("video, iframe").forEach(function (el, i) {
      if (i === 0) return;
      if (el.tagName === "IFRAME") {
        el.setAttribute("loading", "lazy");
      }
      if (el.tagName === "VIDEO") {
        el.setAttribute("preload", "none");
        try {
          if (!el.paused) el.pause();
        } catch (e) {}
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", optimizeMedia, { once: true });
  } else {
    optimizeMedia();
  }

  // Second pass after theme/app media injects
  window.addEventListener("load", function () {
    setTimeout(optimizeMedia, 400);
  });
})();

/* LuxeTM / Luxe Foundation — minimal sticky Add to cart */
(function () {
  if (!document.body || !document.body.classList.contains("template-product-luxe-foundation")) {
    return;
  }

  var ATC_SELECTORS = [
    ".shop-add-to-cart-button",
    "button.shop-add-to-cart-button",
    '.shop-add-to-cart-wrapper button[name="add"]',
    '.product-form button[name="add"]:not([id*="shipping_protection"])',
    'button[name="add"]:not([id*="shipping_protection"]):not(.gb-product-shipping-protection-product-tirgger)',
    "button.product-form__submit:not([id*='shipping_protection'])",
    'form[action*="/cart/add"] button[type="submit"]:not([id*="shipping_protection"])',
    "#ProductSubmitButton",
    '[id^="ProductSubmitButton-"]',
  ];

  var bar = null;
  var btn = null;
  var primaryAtc = null;
  var isVisible = false;
  var pastAtc = false;
  var rafPending = false;
  var clickLock = false;

  function findPrimaryAtc() {
    for (var i = 0; i < ATC_SELECTORS.length; i++) {
      var nodes = document.querySelectorAll(ATC_SELECTORS[i]);
      for (var j = 0; j < nodes.length; j++) {
        var el = nodes[j];
        if (!el || el.closest(".beaumont-luxe-sticky-atc") || el.closest("#stickyAddToCart")) continue;
        if (String(el.id || "").indexOf("shipping_protection") !== -1) continue;
        if (el.offsetParent === null && el.getClientRects().length === 0) continue;
        return el;
      }
    }
    return null;
  }

  function isCartOpen() {
    if (
      document.documentElement.classList.contains("essential-cart-open") ||
      document.body.classList.contains("essential-cart-open")
    ) {
      return true;
    }
    var portal = document.getElementById("essential-cart-drawer-portal");
    if (
      portal &&
      (portal.classList.contains("essential-cart-drawer-open") ||
        portal.classList.contains("essential-cart-drawer-opening"))
    ) {
      return true;
    }
    return !!(
      document.querySelector(
        "cart-drawer.drawer.active, cart-drawer.drawer.is-open, cart-drawer[open], #CartDrawer.active, #CartDrawer.is-open"
      )
    );
  }

  function setVisible(show) {
    if (!bar || show === isVisible) return;
    isVisible = show;
    if (show) {
      bar.classList.add("is-visible");
      bar.setAttribute("aria-hidden", "false");
      document.body.classList.add("beaumont-luxe-sticky-atc-open");
    } else {
      bar.classList.remove("is-visible");
      bar.setAttribute("aria-hidden", "true");
      document.body.classList.remove("beaumont-luxe-sticky-atc-open");
    }
  }

  function atcIsPast() {
    var target = primaryAtc || findPrimaryAtc();
    if (!target) return false;
    primaryAtc = target;
    return target.getBoundingClientRect().bottom < 8;
  }

  function evaluate() {
    if (isCartOpen()) {
      setVisible(false);
      return;
    }
    pastAtc = atcIsPast();
    setVisible(pastAtc);
  }

  function scheduleEvaluate() {
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(function () {
      rafPending = false;
      evaluate();
    });
  }

  var CART_ICON_SVG =
    '<span class="beaumont-luxe-sticky-atc__icon" aria-hidden="true">' +
    '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
    '<circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle>' +
    '<path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>' +
    "</svg></span>";

  function defaultLabelHtml() {
    return (
      CART_ICON_SVG +
      '<span class="beaumont-luxe-sticky-atc__text">Add to Cart</span>'
    );
  }

  function syncLabelFromPrimary() {
    if (!btn) return;
    var target = primaryAtc || findPrimaryAtc();
    if (!target) {
      btn.innerHTML = defaultLabelHtml();
      btn.setAttribute("aria-label", "Add to Cart");
      return;
    }
    primaryAtc = target;
    var icon = target.querySelector(".button-icon");
    var textEl = target.querySelector(".button-text");
    var parts = [];
    if (icon) {
      parts.push(
        '<span class="beaumont-luxe-sticky-atc__icon" aria-hidden="true">' +
          icon.innerHTML +
          "</span>"
      );
    } else {
      parts.push(CART_ICON_SVG);
    }
    var label = "Add to Cart";
    if (textEl) {
      label = (textEl.textContent || "").replace(/\s+/g, " ").trim() || label;
    }
    parts.push(
      '<span class="beaumont-luxe-sticky-atc__text">' +
        label.replace(/</g, "&lt;") +
        "</span>"
    );
    btn.innerHTML = parts.join("");
    btn.setAttribute("aria-label", label);
  }

  function buildBar() {
    if (document.querySelector(".beaumont-luxe-sticky-atc")) {
      bar = document.querySelector(".beaumont-luxe-sticky-atc");
      btn = bar.querySelector(".beaumont-luxe-sticky-atc__btn");
      syncLabelFromPrimary();
      return;
    }
    bar = document.createElement("div");
    bar.className = "beaumont-luxe-sticky-atc";
    bar.setAttribute("aria-hidden", "true");
    bar.innerHTML =
      '<button type="button" class="beaumont-luxe-sticky-atc__btn" aria-label="Add to Cart">' +
      defaultLabelHtml() +
      "</button>";
    btn = bar.firstElementChild;
    document.body.appendChild(bar);
    syncLabelFromPrimary();

    btn.addEventListener("click", function (e) {
      e.preventDefault();
      if (clickLock) return;
      var target = primaryAtc || findPrimaryAtc();
      if (!target) return;
      primaryAtc = target;
      clickLock = true;
      btn.disabled = true;
      try {
        target.click();
      } catch (err) {}
      setTimeout(function () {
        clickLock = false;
        if (btn) btn.disabled = false;
      }, 900);
    });
  }

  function observePrimary() {
    primaryAtc = findPrimaryAtc();
    syncLabelFromPrimary();
    if (primaryAtc && typeof IntersectionObserver !== "undefined") {
      var io = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          if (!entry) return;
          pastAtc = !entry.isIntersecting && entry.boundingClientRect.bottom < 8;
          scheduleEvaluate();
        },
        { root: null, threshold: [0, 0.01, 1], rootMargin: "0px 0px 0px 0px" }
      );
      io.observe(primaryAtc);
    }

    window.addEventListener("scroll", scheduleEvaluate, { passive: true });
    window.addEventListener("resize", scheduleEvaluate, { passive: true });
    [
      "cart:open",
      "cart:close",
      "cart-drawer:open",
      "cart-drawer:close",
      "essential-cart:open",
      "essential-cart:close",
    ].forEach(function (evt) {
      document.addEventListener(evt, scheduleEvaluate);
    });

    var cartMo = new MutationObserver(scheduleEvaluate);
    cartMo.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });
    cartMo.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });

    evaluate();
  }

  function start() {
    buildBar();
    if (findPrimaryAtc()) {
      observePrimary();
      return;
    }
    var mo = new MutationObserver(function () {
      if (findPrimaryAtc()) {
        mo.disconnect();
        observePrimary();
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () {
      mo.disconnect();
      observePrimary();
    }, 8000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      setTimeout(start, 80);
    });
  } else {
    setTimeout(start, 80);
  }
})();
